import { unitById } from "@zend/content";
import { AssetIcon } from "../assets/Icon.js";
import { RoleIcon } from "../assets/gameIcons.js";
import { pick, useT } from "../i18n/index.js";
import { Stars, tierColor } from "../units/shared.js";
import type { MarchSquad } from "./types.js";

/** Real pipeline portraits for every recorded member, including supports. No synthetic roster filler. */
export function SquadPreview({ squad }: { squad: MarchSquad | null | undefined }) {
  const t = useT();
  if (!squad) return <p className="hint" data-testid="march-snapshot-unavailable">{t("world.march.snapshotUnavailable")}</p>;
  return <div className="march-squad-preview" data-testid="march-squad-preview">
    <strong>{squad.name} <span className="hint">{t("world.squadSize", { n: squad.members.length })}</span></strong>
    <div className="march-members">{squad.members.map((member) => {
      const definition = unitById(member.unitId);
      return <div className="march-member" key={member.rowId} data-unit-id={member.unitId} data-unit-row={member.rowId} data-slot={member.slot} style={{ borderColor: tierColor(definition.tier) }}>
        <AssetIcon id={member.unitId} portrait size={64} alt={pick(definition.name)} />
        <span className="march-member-name">{pick(definition.name)}</span>
        <span className="march-member-meta"><RoleIcon role={definition.role} size={15} /> L{member.level}</span>
        <Stars stars={member.stars} size={10} />
      </div>;
    })}</div>
  </div>;
}
